// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: oBrjhwG3w6I
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import SelectState from "../../SelectState"; // plasmic-import: EbL1EK3L-GE/component
import { useScreenVariants as useScreenVariantsnoO6HAIuEe } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: NoO6H-AIuEE/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicOnboardingPersonalDetailsRetry.module.css"; // plasmic-import: oBrjhwG3w6I/css
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: YS4jDAKGMbE/icon
import DividerLineVerticalIcon from "./icons/PlasmicIcon__DividerLineVertical"; // plasmic-import: Ql4i0eZ6cYO/icon

createPlasmicElementProxy;

export const PlasmicOnboardingPersonalDetailsRetry__VariantProps = new Array();

export const PlasmicOnboardingPersonalDetailsRetry__ArgProps = new Array();

const $$ = {};

function PlasmicOnboardingPersonalDetailsRetry__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "selectState.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsnoO6HAIuEe()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__oRes)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__wdjem
              )}
            >
              {"Account Information"}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__oMlo5)}>
            <div className={classNames(projectcss.all, sty.freeBox__avNdb)}>
              <div
                data-plasmic-name={"lineStack"}
                data-plasmic-override={overrides.lineStack}
                className={classNames(projectcss.all, sty.lineStack)}
              >
                <div
                  data-plasmic-name={"circle"}
                  data-plasmic-override={overrides.circle}
                  className={classNames(projectcss.all, sty.circle)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__wsbF7)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__n1Ii)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__wXem8)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle2"}
                  data-plasmic-override={overrides.circle2}
                  className={classNames(projectcss.all, sty.circle2)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__d74Of)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__anYwd)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__sW5Q)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle3"}
                  data-plasmic-override={overrides.circle3}
                  className={classNames(projectcss.all, sty.circle3)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg___7FRw9)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__mrdu4)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__bbidd)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle4"}
                  data-plasmic-override={overrides.circle4}
                  className={classNames(projectcss.all, sty.circle4)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__xxl1N)}
                    role={"img"}
                  />
                </div>
              </div>
            </div>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__e2WwI)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__qdC32
                )}
              >
                {"Setup Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__wl7Gi
                )}
              >
                {"Personal Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__swhAn
                )}
              >
                {"Banking Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___1S3Eo
                )}
              >
                {"Retry & Submit"}
              </div>
            </p.Stack>
            <div className={classNames(projectcss.all, sty.freeBox__abHRg)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__ewZ4S
                )}
              >
                {
                  "It looks like your account wasn't immediately approved by our compliance partners. Please try again by re-entering your information below. "
                }
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__mdmxw)}>
                <div className={classNames(projectcss.all, sty.freeBox__yJc3)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__gQa7
                    )}
                  >
                    {"First Name"}
                  </div>
                  <input
                    data-plasmic-name={"firstName"}
                    data-plasmic-override={overrides.firstName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.firstName
                    )}
                    placeholder={"First"}
                    ref={ref => {
                      $refs["firstName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={""}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__rvTtc)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__cVvn3
                    )}
                  >
                    {"Last Name"}
                  </div>
                  <input
                    data-plasmic-name={"lastName"}
                    data-plasmic-override={overrides.lastName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.lastName
                    )}
                    placeholder={"Last"}
                    ref={ref => {
                      $refs["lastName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={""}
                  />
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox___3BSaS)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___8B1Ly
                  )}
                >
                  {"Address"}
                </div>
                <input
                  data-plasmic-name={"textInput"}
                  data-plasmic-override={
                    overrides.textInput ?? overrides.textbox
                  }
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.textInput
                  )}
                  placeholder={"12-3456789"}
                  size={1}
                  type={"text"}
                  value={"United States"}
                />

                <input
                  data-plasmic-name={"address1"}
                  data-plasmic-override={overrides.address1}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.address1
                  )}
                  placeholder={"Address Line"}
                  ref={ref => {
                    $refs["address1"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />

                <input
                  data-plasmic-name={"city"}
                  data-plasmic-override={overrides.city}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.city
                  )}
                  placeholder={"City"}
                  ref={ref => {
                    $refs["city"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />

                <SelectState
                  data-plasmic-name={"selectState"}
                  data-plasmic-override={overrides.selectState}
                  className={classNames("__wab_instance", sty.selectState)}
                  onChange={(...eventArgs) => {
                    p.generateStateOnChangeProp($state, [
                      "selectState",
                      "value"
                    ])(eventArgs[0]);
                  }}
                  placeholder={"State"}
                  value={p.generateStateValueProp($state, [
                    "selectState",
                    "value"
                  ])}
                />

                <input
                  data-plasmic-name={"zip"}
                  data-plasmic-override={overrides.zip}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.zip
                  )}
                  placeholder={"ZIP"}
                  ref={ref => {
                    $refs["zip"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__hqTqL)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__njf1H
                  )}
                >
                  {"Date of Birth"}
                </div>
                <div
                  data-plasmic-name={"dob"}
                  data-plasmic-override={overrides.dob}
                  className={classNames(projectcss.all, sty.dob)}
                />
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__vo2UE)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__mV19A
                  )}
                >
                  {"Social Security Number (9 Digits)"}
                </div>
                <input
                  data-plasmic-name={"ssn"}
                  data-plasmic-override={overrides.ssn}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.ssn
                  )}
                  placeholder={"123-45-6789"}
                  ref={ref => {
                    $refs["ssn"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />
              </div>
              <div
                data-plasmic-name={"errorText"}
                data-plasmic-override={overrides.errorText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.errorText
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div
                data-plasmic-name={"continueButton"}
                data-plasmic-override={overrides.continueButton}
                className={classNames(projectcss.all, sty.continueButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__w0QTj
                  )}
                >
                  {"Submit"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "firstName",
    "lastName",
    "textInput",
    "textbox",
    "address1",
    "city",
    "selectState",
    "zip",
    "dob",
    "ssn",
    "errorText",
    "continueButton"
  ],

  lineStack: ["lineStack", "circle", "circle2", "circle3", "circle4"],
  circle: ["circle"],
  circle2: ["circle2"],
  circle3: ["circle3"],
  circle4: ["circle4"],
  firstName: ["firstName"],
  lastName: ["lastName"],
  textInput: ["textInput", "textbox"],
  address1: ["address1"],
  city: ["city"],
  selectState: ["selectState"],
  zip: ["zip"],
  dob: ["dob"],
  ssn: ["ssn"],
  errorText: ["errorText"],
  continueButton: ["continueButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOnboardingPersonalDetailsRetry__ArgProps,
          internalVariantPropNames:
            PlasmicOnboardingPersonalDetailsRetry__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOnboardingPersonalDetailsRetry__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicOnboardingPersonalDetailsRetry";
  } else {
    func.displayName = `PlasmicOnboardingPersonalDetailsRetry.${nodeName}`;
  }
  return func;
}

export const PlasmicOnboardingPersonalDetailsRetry = Object.assign(
  // Top-level PlasmicOnboardingPersonalDetailsRetry renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    lineStack: makeNodeComponent("lineStack"),
    circle: makeNodeComponent("circle"),
    circle2: makeNodeComponent("circle2"),
    circle3: makeNodeComponent("circle3"),
    circle4: makeNodeComponent("circle4"),
    firstName: makeNodeComponent("firstName"),
    lastName: makeNodeComponent("lastName"),
    textInput: makeNodeComponent("textInput"),
    address1: makeNodeComponent("address1"),
    city: makeNodeComponent("city"),
    selectState: makeNodeComponent("selectState"),
    zip: makeNodeComponent("zip"),
    dob: makeNodeComponent("dob"),
    ssn: makeNodeComponent("ssn"),
    errorText: makeNodeComponent("errorText"),
    continueButton: makeNodeComponent("continueButton"),
    // Metadata about props expected for PlasmicOnboardingPersonalDetailsRetry
    internalVariantProps: PlasmicOnboardingPersonalDetailsRetry__VariantProps,
    internalArgProps: PlasmicOnboardingPersonalDetailsRetry__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicOnboardingPersonalDetailsRetry;
/* prettier-ignore-end */
